import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export default function MarkdownText({ text, className = "" }) {
  if (typeof text !== "string" || !text.trim()) return null;

  return (
    <div className={`text-sm leading-relaxed ${className}`.trim()}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          p: ({ node, children, ...props }) => (
            <p className="text-sm leading-relaxed whitespace-pre-wrap" {...props}>
              {children}
            </p>
          ),
          strong: ({ node, children, ...props }) => (
            <strong className="font-semibold" {...props}>
              {children}
            </strong>
          ),
          em: ({ node, children, ...props }) => (
            <em className="italic" {...props}>
              {children}
            </em>
          ),
          ul: ({ node, children, ...props }) => (
            <ul className="list-disc pl-5 space-y-1 my-2" {...props}>
              {children}
            </ul>
          ),
          ol: ({ node, children, ...props }) => (
            <ol className="list-decimal pl-5 space-y-1 my-2" {...props}>
              {children}
            </ol>
          ),
          li: ({ node, children, ...props }) => (
            <li className="text-sm leading-relaxed" {...props}>
              {children}
            </li>
          ),
          a: ({ node, children, ...props }) => (
            <a
              className="text-[#6036C4] hover:text-[#5028b0] underline"
              target="_blank"
              rel="noreferrer"
              {...props}
            >
              {children}
            </a>
          ),
          code: ({ node, inline, className: codeClassName, children, ...props }) =>
            inline ? (
              <code
                className="px-1 py-0.5 rounded bg-gray-200 text-[0.85em] font-mono"
                {...props}
              >
                {children}
              </code>
            ) : (
              <code
                className={`block whitespace-pre-wrap break-words rounded bg-gray-900 text-gray-100 p-3 text-xs font-mono ${
                  codeClassName || ""
                }`}
                {...props}
              >
                {children}
              </code>
            ),
          pre: ({ node, children, ...props }) => (
            <pre className="my-2" {...props}>
              {children}
            </pre>
          ),
          blockquote: ({ node, children, ...props }) => (
            <blockquote
              className="border-l-4 border-gray-300 pl-3 my-2 text-gray-700"
              {...props}
            >
              {children}
            </blockquote>
          ),
          hr: ({ node, ...props }) => (
            <hr className="my-3 border-gray-200" {...props} />
          ),
        }}
      >
        {text}
      </ReactMarkdown>
    </div>
  );
}

